import React, {useEffect, useState} from 'react';
import { Styles } from '../../../config/design/styles';
import { withStyles } from "@mui/styles";
import { connect } from "trim-redux";
import {useTranslation} from "react-i18next";
import {Box, IconButton, Typography} from "@mui/material";
import {isAdmin} from "../../../config/Permissions";
import AdminDashboard from "./AdminDashboard";
import SupplierDashboard from "./SupplierDashboard";

const Dashboards = ({ classes,user }) => {
    const { t } = useTranslation();

    return (
        <>
            {
                !!isAdmin() ?
                    <AdminDashboard/>
                    :
                    <SupplierDashboard/>
            }
        </>

    );
};

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
});

export default withStyles(Styles)(connect(mstp)(Dashboards));
